import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Textarea } from "@/components/ui/textarea"
import { StarRating } from "@/components/Atoms/StarRating"
import { useState } from "react"
import { MentoriaDataType } from "@/types/mentorias"
import { PendingMentoringsRateResponse } from "@/services/mentoriasService"
import { format, parseISO, isValid } from "date-fns"

type MentoringInfo = (PendingMentoringsRateResponse & { mentor_nome?: string }) | MentoriaDataType

interface MentoringFeedbackModalProps {
  isOpen: boolean
  onClose: () => void
  mentoring: MentoringInfo
  onSubmit: (rating: number, comments: string) => void
}

export function MentoringFeedbackModal({
  isOpen,
  onClose,
  mentoring,
  onSubmit,
}: MentoringFeedbackModalProps) {
  const [rating, setRating] = useState(0)
  const [comments, setComments] = useState("")

  const handleSubmit = () => {
    onSubmit(rating, comments)
    onClose()
  }

  return (
    <Dialog
      open={isOpen}
      onOpenChange={onClose}
    >
      <DialogContent className="max-w-[350px]">
        <DialogHeader>
          <DialogTitle>Avaliação da Mentoria</DialogTitle>
          <DialogDescription>
            Avalie a sua experiência com a mentoria para nos ajudar a melhorar.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-2">
          <div className="flex flex-col gap-4">
            <div className="space-y-2 rounded-sm border p-4">
              <p>
                <strong>Mentoria:</strong> {mentoring.descricao_mentoria}
              </p>
              <p>
                <strong>Data:</strong> {(() => {
                  const d = mentoring.data_hora_mentoria ? parseISO(mentoring.data_hora_mentoria) : null
                  return d && isValid(d) ? format(d, "dd/MM/yyyy") : "—"
                })()}
              </p>
              {(mentoring as MentoriaDataType).mentor_nome && (
                <p>
                  <strong>Mentor:</strong> {(mentoring as MentoriaDataType).mentor_nome}
                </p>
              )}
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-2">
            <p className="text-lg">Sua avaliação</p>
            <StarRating
              rating={rating}
              onChange={setRating}
            />
          </div>
          <div className="grid grid-cols-1 items-center gap-2">
            <p className="text-sm font-medium">Comentários</p>
            <Textarea
              placeholder="Digite seus comentários..."
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            disabled={rating === 0}
            type="button"
            onClick={handleSubmit}
          >
            Enviar Avaliação
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
